
import { Mapper } from "../../../../base/utils/mapper";
import { HypotoniaNeurologyModel } from "../../../../domain/models/consult/hypotonia-neurology.model";
import { HypotoniaNeurologyEntity } from "../entities/hypotonia-neurology.entity";
        export class HypotoniaNeurologyImplementationRepositoryRepositoryMapper extends Mapper<HypotoniaNeurologyEntity, HypotoniaNeurologyModel>{
            mapFrom(param:  HypotoniaNeurologyEntity):  HypotoniaNeurologyModel { 
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors
                }; 
            }
            mapTo(param:  HypotoniaNeurologyModel):  HypotoniaNeurologyEntity {
                return {
                    data:param.data,
                    isSuccess:param.isSuccess,
                    message:param.message,
                    errors:param.errors 
                };
            }
        }